import { SecurityDetails } from "@models/simulations/securityDetails";
import { TradeValidity } from "@models/trading/TradeValidity";
import { Locality } from "@services/cmodel.repo";

class SimulationTradeValidityModal implements angular.IOnInit {
  public securityDetails: SecurityDetails;
  public showBuyValidity: boolean;
  public showSellValidity: boolean;
  public locality: Locality;

  public isLoading: boolean = false;

  public buyValidity: TradeValidity;
  public sellValidity: TradeValidity;

  public showUseCase: boolean = false;

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService,
    private notifyjs: any
  ) {}

  $onInit(): void {
    if (this.showBuyValidity) {
      this.buyValidity = new TradeValidity(this.securityDetails);
      // console.log(this.buyValidity);
    }

    if (this.showSellValidity) {
      this.sellValidity = new TradeValidity(this.securityDetails);
      // console.log(this.sellValidity);
    }
  }

  submitTradeValidities() {
    this.isLoading = true;

    if (this.showBuyValidity && this.buyValidity.validTill) {
      const actualDate = new Date(
        Date.UTC(
          this.buyValidity.validTill.getFullYear(),
          this.buyValidity.validTill.getMonth(),
          this.buyValidity.validTill.getDate()
        )
      );
      this.buyValidity.validTill = actualDate;
    }

    if (this.showSellValidity && this.sellValidity.validTill) {
      const actualDate = new Date(
        Date.UTC(
          this.sellValidity.validTill.getFullYear(),
          this.sellValidity.validTill.getMonth(),
          this.sellValidity.validTill.getDate()
        )
      );
      this.sellValidity.validTill = actualDate;
    }

    this.$mdDialog.hide({
      buyValidity: this.buyValidity,
      sellValidity: this.sellValidity,
    });
  }

  closeDialog() {
    this.$mdDialog.cancel();
  }
}

export const simulationTradeValidity: angular.IComponentOptions = {
  template: require("./tradeValiditySimulation.modal.html"),
  controller: SimulationTradeValidityModal,
  bindings: {
    securityDetails: "<",
    showBuyValidity: "<",
    showSellValidity: "<",
    locality: "<",
    showUseCase: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/simulations/tradeValiditySimulation.modal.ts